var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-checkbox",
        {
          staticClass: "bb-checkbox",
          attrs: {
            size: "lg",
            "aria-describedby": _vm.elementId,
            "aria-controls": _vm.elementId,
          },
          on: { change: _vm.toggleAll },
          model: {
            value: _vm.allChecked,
            callback: function ($$v) {
              _vm.allChecked = $$v
            },
            expression: "allChecked",
          },
        },
        [_vm._v(" " + _vm._s(_vm.allLabel) + " ")]
      ),
      _c("b-form-checkbox-group", {
        staticClass: "ml-0 bb-checkbox",
        attrs: {
          id: _vm.elementId,
          options: _vm.options,
          name: _vm.elementId,
          stacked: "",
          size: "lg",
        },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }